import styled from 'styled-components';
export const RatingDivider = /*#__PURE__*/styled.hr.withConfig({
  displayName: "Ratingsstyles__RatingDivider",
  componentId: "sc-1j6wodr-0"
})(["width:1px;height:16px;background-color:rgba(0,24,51,1);margin:0px 8px;border:0px;"]);